import { createContext } from "react";

export type ConfettiContextType = {
    requestConfetti: () => void;
    setTaskOpen: (open: boolean) => void;
};

export const ConfettiContext = createContext<ConfettiContextType | null>(null);
